import React from 'react'

const Badges = () => (
  <section><a className="anchor" id="badges"></a>
    <h2>Badges</h2>
    Badges are intended to be used for indicating a status or stage and have built-in variations.
    <p>We recommend a maximum of 20 characters to be used, anything beyond this may be more suited for an alert.</p>
    <h4>Sizing </h4>
    <p>Add a <code>badge--small</code>, <code>badge--medium</code>, <code>badge--large</code> for different sized badges.</p>
    <div className="display--inline-block">
      <span className="badge badge--small">Small Badge</span>
      <span className="badge">Default Badge</span>
      <span className="badge badge--medium">Medium Badge</span>
      <span className="badge badge--large">Large Badge</span>
    </div>
    <br/>
    <pre>
      <code className="language-html">
        {`<span class="badge badge--small">Small Badge</span>
<span class="badge">Default Badge</span>
<span class="badge badge--medium">Medium Badge</span>
<span class="badge badge--large">Large Badge</span>`}
      </code>
    </pre>
    <br/><br/>
    <h4>Coloring </h4>
    <div className="display--inline-block">
      <span className="badge">Default</span>
      <span className="badge badge--blue-6">Sky Blue</span>
      <span className="badge badge--red-4">Coral Red</span>
      <span className="badge badge--orange-1">orange-1</span>
      <span className="badge badge--green-4">green-4</span>
      <span className="badge badge--purple-3">Trendy Pink</span>
      <span className="badge badge--teal-4">teal-4</span>
      <span className="badge badge--orange-2">Tree Poppy</span>
    </div>
    <br/>
    <pre>
      <code className="language-html">
        {`<span class="badge">Default</span>
<span class="badge badge--blue-6">Sky Blue</span>
<span class="badge badge--red-4">Coral Red</span>
<span class="badge badge--orange-1">orange-1</span>
<span class="badge badge--green-4">green-4</span>
<span class="badge badge--purple-3">Trendy Pink</span>
<span class="badge badge--teal-4">teal-4</span>
<span class="badge badge--orange-2">Tree Poppy</span>`}
      </code>
    </pre>
    <br/><br/>
    <h4>Ghost Badges </h4>
    <p>Add <code>badge--ghost</code> to achieve the following ghosted effect:</p>
    <span className="badge badge--ghost">Default Ghost</span>
    <span className="badge badge--blue-6 badge--ghost">Sky Blue Ghost</span>
    <span className="badge badge--red-4 badge--ghost">Coral Red Ghost</span>
    <span className="badge badge--orange-1 badge--ghost">orange-1 Ghost</span>
    <span className="badge badge--green-4 badge--ghost">green-4 Ghost</span>
    <span className="badge badge--purple-3 badge--ghost">Trendy Pink Ghost</span>
    <span className="badge badge--teal-4 badge--ghost">teal-4 Ghost</span>
    <span className="badge badge--orange-2 badge--ghost">Tree Poppy Ghost</span>
    <br/><br/>
    <div className="reversed__background display--inline-block">
      <span className="badge badge--ghost">Default Ghost</span>
      <span className="badge badge--blue-6 badge--ghost">Sky Blue Ghost</span>
      <span className="badge badge--red-4 badge--ghost">Coral Red Ghost</span>
      <span className="badge badge--orange-1 badge--ghost">orange-1 Ghost</span>
      <span className="badge badge--green-4 badge--ghost">green-4 Ghost</span>
      <span className="badge badge--purple-3 badge--ghost">Trendy Pink Ghost</span>
      <span className="badge badge--teal-4 badge--ghost">teal-4 Ghost</span>
      <span className="badge badge--orange-2 badge--ghost">Tree Poppy Ghost</span>
    </div>
    <br/>
    <pre>
      <code className="language-html">
        {`<span class="badge badge--ghost">Default Ghost</span>
<span class="badge badge--blue-6 badge--ghost">Sky Blue Ghost</span>
<span class="badge badge--red-4 badge--ghost">Coral Red Ghost</span>
<span class="badge badge--orange-1 badge--ghost">orange-1 Ghost</span>
<span class="badge badge--green-4 badge--ghost">green-4 Ghost</span>
<span class="badge badge--purple-3 badge--ghost">Trendy Pink Ghost</span>
<span class="badge badge--teal-4 badge--ghost">teal-4 Ghost</span>
<span class="badge badge--orange-2 badge--ghost">Tree Poppy Ghost</span>`}
      </code>
    </pre>
    <br/>
    <p className="callout"><b>Note: </b>We recommend avoiding using the <code>trendy--pink</code> ghost on dark backgrounds due to poor visibility.</p>
    <br/><br/>
    <h4>Icon Badges </h4>
    <div className="display--inline-block">
      <span className="badge badge--green-4"><i className="fa fa-plus"></i> Plus Badge</span>
      <span className="badge badge--teal-4">Minus Badge <i className="fa fa-minus"></i></span>
      <span className="badge badge--purple-3"><i className="fa fa-check"></i> Check Badge</span>
      <span className="badge badge--orange-2">Check Badge <i className="fa fa-check-circle"></i></span>
      <span className="badge badge--teal-4 badge--teal-4--ghost">Send Badge <i className="fa fa-send"></i></span>
      <span className="badge badge--green-4 badge--green-4--ghost">Wifi <i className="fa fa-wifi"></i> Badge</span>
    </div>
    <br/>
    <pre>
      <code className="language-html">
        {`<span class="badge badge--green-4"><i class="fa fa-plus"></i> Plus Badge</span>
<span class="badge badge--teal-4">Minus Badge <i class="fa fa-minus"></i></span>
<span class="badge badge--purple-3"><i class="fa fa-check"></i> Check Badge</span>
<span class="badge badge--orange-2">Check Badge <i class="fa fa-check-circle"></i></span>
<span class="badge badge--teal-4 badge--teal-4--ghost">Send Badge <i class="fa fa-send"></i></span>
<span class="badge badge--green-4 badge--green-4--ghost">Wifi <i class="fa fa-wifi"></i> Badge</span`}
      </code>
    </pre>
    <br/>
    <hr />
  </section>
)


export default Badges



// WEBPACK FOOTER //
// ./styleguide/components/sections/Badges.js